export default {
  supportedLngs: ["sv", "en"] as const,
  debug: false,
  fallbackLng: "sv" as const,
  defaultNS: ["common", "models", "ui", "validation"] as const,
  react: { useSuspense: false },
};
